"use client";
import React, { useRef } from "react";
import Image from "next/image";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import Beer from "../../../../public/assets/client/beer/abinbev.webp";
import Beer2 from "../../../../public/assets/client/beer/godfather.webp";
import Beer3 from "../../../../public/assets/client/beer/cg.png";
import Beer4 from "../../../../public/assets/client/beer/grag-trader.png";
import Beer5 from "../../../../public/assets/client/beer/ub.png";

gsap.registerPlugin(ScrollTrigger);

const clientImages = [Beer, Beer2, Beer3, Beer4, Beer5];

const BeerClientsMobile = () => {
  const sectionRef = useRef(null);
  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    autoplay: true,
    autoplaySpeed: 2500,
    slidesToShow: 2,
    slidesToScroll: 2,
    responsive: [
      { breakpoint: 1280, settings: { slidesToShow: 4 } },
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 2 } },
    ],
  };

  return (
    <section
      className="bg-white pb-[50px] pt-[60px] overflow-x-hidden !mb-3 block xl:hidden"
      ref={sectionRef}
    >
      <div className="container mx-auto">
        <h2 className="title !text-center !mb-5 !text-[#033b6f]">
          Our <span className="text-[#d42427]"> Clients</span>
        </h2>

        <Slider {...settings}>
          {clientImages.map((img, i) => (
            <div key={i} className="px-3">
              <div className="border border-gray-200 shadow-2xl rounded-lg p-2 bg-white transition-all duration-300 hover:scale-105">
                <Image
                  src={img}
                  alt={`client-${i}`}
                  className=" rounded-lg object-contain"
                />
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default BeerClientsMobile;
